import {
  Strategy,
  OptionContract,
  LegType,
} from '@oai-frontend-monorepo/types';
import parseLegTypeFromTradeRef from '../strategy/parseLegTypeFromTradeRef';
import SymbolParser from '../symbol/SymbolParser';

interface Params {
  strategy: Strategy;
  optionContracts: OptionContract[];
}

const getLegsFromTrade = ({ optionContracts, strategy }: Params) => {
  const legs = optionContracts.map((c) => {
    return {
      legType: parseLegTypeFromTradeRef({
        symbol: new SymbolParser(c.symbol).symbol,
        tradeRef: {
          strategy: strategy,
          underlyingSymbol: '',
          symbols: optionContracts.map(
            (c) => new SymbolParser(c.symbol).symbol
          ),
        },
      })!,
      optionContract: {
        ...c,
        symbol: new SymbolParser(c.symbol).symbol,
      },
    };
  });

  const longCall = legs.find((l) => l.legType === LegType.LONG_CALL);
  const shortCall = legs.find((l) => l.legType === LegType.SHORT_CALL);
  const shortPut = legs.find((l) => l.legType === LegType.SHORT_PUT);
  const longPut = legs.find((l) => l.legType === LegType.LONG_PUT);

  return {
    longCall,
    shortCall,
    shortPut,
    longPut,
  };
};

export default getLegsFromTrade;
